import {
  Box,
  Button,
  Dialog,
  DialogActions,
  Grid,
  Autocomplete,
  TextField,
  DialogContent,
  DialogContentText,
  DialogTitle,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  IconButton,
  TableSortLabel,
  TablePagination,
} from "@mui/material";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { usePermiteAcesso } from "../../Components/Funcionais/Utils";
import SessaoAuth from "../../Hooks/SessaoAuth";
import CreateIcon from "@mui/icons-material/Create";
import DeleteIcon from "@mui/icons-material/Delete";
import AddIcon from "@mui/icons-material/Add";
import APIAxios from "../../Api/APIAxios";
import PageTitle from "../../Components/Layout/PageTitle";

const CalendarioList = () => {
  //***************************************   AVISOS E LOADING ************************************************* */
  // CONTROLE DE AVISOS E ALERTAS
  //Funcão para fechar avisos e alertas
  usePermiteAcesso(6); //Jornadas
  const [avisoErro, setAvisoErro] = useState("");
  const [avisoSucesso, setAvisoSucesso] = useState("");
  const [loading, setLoading] = useState(false);
  //************************************************************************************************** */

  const { sessao, setSessao } = SessaoAuth();

  const setRowsPerPage = (newRowsPerPage) => {
    setSessao((prev) => ({ ...prev, rowsPerPage: newRowsPerPage }));
  };

  const apiAxios = APIAxios();
  const navigate = useNavigate(); // Hook para navegação

  const [calendar, setCalendar] = useState([]);
  const [selectedCalendar, setSelectedCalendar] = useState(null);
  const [openExcluir, setOpenExcluir] = useState(false);
  const [page, setPage] = useState(0);
  const [sortColumn, setSortColumn] = useState(null); // Coluna ordenada
  const [sortDirection, setSortDirection] = useState("asc"); // Direção da ordenação
  const [valorSelecionado, setValorSelecionado] = useState("");
  const [cmpSelecao, setCmpSelecao] = useState(20);

  // Janela para confirmar Delete
  const excluirJornada = () => {
    deleteCalendars(selectedCalendar.id);
    setOpenExcluir(false);
    setAvisoSucesso("Jornada excluída com sucesso.");
  };

  //Consultar Calendários
  const fetchCalendars = async () => {
    try {
      setAvisoErro("");
      setLoading(true);

      const response = await apiAxios.get("/calendarios");

      setCalendar(response.data.data);
    } catch (error) {
      setAvisoErro(error.message);
    } finally {
      setLoading(false);
    }
  };

  //Apagar Calendários
  const deleteCalendars = async (cal) => {
    try {
      setAvisoErro("");
      setLoading(true);

      const response = await apiAxios.delete("/calendario/" + cal);

      if (response?.data?.sucesso !== "SIM") {
        setAvisoErro(response.data?.data);
      }

      if (response.status === 200) {
        fetchCalendars();
      }
    } catch (error) {
      if (error?.response?.data) {
        setAvisoErro(error?.response?.data.data);
      } else {
        setAvisoErro(error.message);
      }
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    // Função para buscar dados da API
    fetchCalendars();
  }, []);

  // Função para manipular a ordenação
  const handleSort = (column) => {
    const isAsc = sortColumn === column && sortDirection === "asc";
    setSortDirection(isAsc ? "desc" : "asc");
    setSortColumn(column);
  };

  // Funções para abrir e fechar o menu de opções
  const handleEdit = (event, calendar) => {
    navigate(`/jornada/${calendar.id}`);
  };

  const handleIncluir = () => {
    navigate(`/jornada`);
  };

  const handleClickOpenExcluir = (e, calendar) => {
    setSelectedCalendar(calendar);
    setOpenExcluir(true);
  };

  const handleClickCloseExcluir = () => {
    setOpenExcluir(false);
  };

  //Função para seleção de filtro
  
const getAutocompleteOptions = () => {
  let options = [];

  switch (cmpSelecao) {
    case 10:
      options = calendar.map((reg) => reg.id);           // números
      break;
    case 20:
      options = calendar.map((reg) => reg.descricao);    // strings
      break;
    case 30:
      options = calendar.map((reg) => (reg.status === "A" ? "Ativo" : "Inativo"));       // strings
      break;
    default:
      return [];
  }

  options = [...new Set(options)];

  options.sort((a, b) => {
    if (typeof a === 'string' && typeof b === 'string') return a.localeCompare(b);
    return Number(a) - Number(b);
  });

  return options.map(String); // <-- tudo vira string
};

// Filtro usando valorSelecionado como string
const Filtrados = valorSelecionado
  ? calendar.filter((reg) => {
      const valor = valorSelecionado.toLowerCase();
      switch (cmpSelecao) {
        case 10:
          return reg.id.toString().includes(valorSelecionado);
        case 20:
          return reg.descricao?.toLowerCase().includes(valor);
        case 30:
          return reg.status === (valor === "ativo" ? "A" : "I");
        default:
          return true;
      }
    })
  : calendar;


  const handleChangePage = (event, newPage) => setPage(newPage);
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  // Função para ordenar os dados com base na coluna selecionada
  const sortedCalendar = [...Filtrados].sort((a, b) => {
    if (!sortColumn) return 0;
    const valueA = a[sortColumn] || "";
    const valueB = b[sortColumn] || "";

    if (typeof valueA === "string") {
      return sortDirection === "asc"
        ? valueA.localeCompare(valueB)
        : valueB.localeCompare(valueA);
    } else {
      return sortDirection === "asc" ? valueA - valueB : valueB - valueA;
    }
  });

  const paginatedData = sortedCalendar.slice(
    page * (sessao.rowsPerPage || 10),
    page * (sessao.rowsPerPage || 10) + (sessao.rowsPerPage || 10)
  );

  useEffect(() => {
    setPage(0);
  }, [Filtrados]);

  return (
    <Box>
      {/***************************************** AVISOS **********************************/}
      <PageTitle
        caption="Jornadas de Trabalho"
        subtitle="Listagem de jornadas de trabalho"
        setAvisoErro={setAvisoErro}
        avisoErro={avisoErro}
        avisoSucesso={avisoSucesso}
        setAvisoSucesso={setAvisoSucesso}
        loading={loading}
        accentStyle
      />
      {/***************************************** AVISOS **********************************/}
      {/* Diálogo para Excluir Colaborador */}
      <Dialog
        open={openExcluir}
        onClose={handleClickCloseExcluir}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {"Deseja excluir esta jornada?"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Após a exclusão, o cadastro não poderá ser recuperado.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClickCloseExcluir}>Cancelar</Button>
          <Button onClick={excluirJornada} autoFocus>
            Confirmar
          </Button>
        </DialogActions>
      </Dialog>
      <Box>
        <Box>
          <Grid container spacing={2} alignItems={"center"} mb={2}>
            {/*Usar meia tela em caso de monitor grande e tela total em monitores pequenos*/}
            <Grid item xs={12} md={3}>
              <Box sx={{ display: "flex", gap: 1, alignItems: "center" }}>
                <FormControl fullWidth>
                  <InputLabel>Filtrar por:</InputLabel>
                  <Select
                    labelId="cmpSelecao"
                    id="cmpSelecao"
                    label="Filtrar por"
                    value={cmpSelecao}
                    onChange={(e) => setCmpSelecao(e.target.value)}
                  >
                    <MenuItem value={10}>Código</MenuItem>
                    <MenuItem value={20}>Descrição</MenuItem>
                    <MenuItem value={30}>Situação</MenuItem>
                  </Select>
                </FormControl>
              </Box>
            </Grid>
            <Grid item xs={12} md={3}>
              
              <Autocomplete
                id="cmpDescricao"
                freeSolo
                options={getAutocompleteOptions()}          // strings
                inputValue={valorSelecionado ?? ''}         // controle do texto
                onInputChange={(_, newValue) => setValorSelecionado(newValue)}
                renderInput={(params) => <TextField {...params} label="Localizar" />}
              />

            </Grid>
            <Grid item xs={12} md={3}></Grid>
            <Grid item xs={12} md={3}>
              <Button
                fullWidth
                variant="contained"
                startIcon={<AddIcon />}
                sx={{ backgroundColor: "#1a3865" }}
                onClick={() => handleIncluir()}
              >
                Incluir Jornada
              </Button>
            </Grid>
          </Grid>

          <Paper sx={{ mt: 2 }} elevation={4}>
            <TableContainer>
              <Table size="small">
                <TableHead>
                  <TableRow>
                    <TableCell align="center">
                      <TableSortLabel
                        active={sortColumn === "id"}
                        direction={sortColumn === "id" ? sortDirection : "asc"}
                        onClick={() => handleSort("id")}
                      >
                        Código
                      </TableSortLabel>
                    </TableCell>
                    <TableCell>
                      <TableSortLabel
                        active={sortColumn === "descricao"}
                        direction={
                          sortColumn === "descricao" ? sortDirection : "asc"
                        }
                        onClick={() => handleSort("descricao")}
                      >
                        Descrição
                      </TableSortLabel>
                    </TableCell>
                    <TableCell align="center">Situação</TableCell>
                    <TableCell align="center">Ações</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {paginatedData.map((calendar) => (
                    <TableRow key={calendar.id}>
                      <TableCell align="center">{calendar.id}</TableCell>
                      <TableCell>{calendar.descricao}</TableCell>
                      <TableCell align="center">{calendar.status === "A" ? "Ativo" : "Inativo"}</TableCell>

                      <TableCell align="center">
                        <Box sx={{ display: "flex", gap: 1, justifyContent: "end" }}>
                        <IconButton
                          aria-label="options"
                          onClick={(event) => handleEdit(event, calendar)}
                        >
                          <CreateIcon style={{ color: "#1a3865" }} />
                        </IconButton>
                        <IconButton
                          aria-label="deletar"
                          onClick={(event) =>
                            handleClickOpenExcluir(event, calendar)
                          }
                        >
                          <DeleteIcon style={{ color: "#f4793c" }} />
                        </IconButton>
                        </Box>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>

            <TablePagination
              component="div"
              count={Filtrados.length}
              page={page}
              onPageChange={handleChangePage}
              rowsPerPage={sessao.rowsPerPage || 10}
              labelRowsPerPage="Linhas por página"
              rowsPerPageOptions={[5, 10, 25]}
              onRowsPerPageChange={handleChangeRowsPerPage}
              justifyContent="bottom"
              sx={{
                "& .MuiTablePagination-toolbar": {
                  alignItems: "center",
                },
                "& p": {
                  marginBottom: 0, // Remove a margem inferior do <p>
                },
              }}
            />
          </Paper>
        </Box>
      </Box>
    </Box>
  );
};

export default CalendarioList;
